import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const Header = styled.div<{
  isActive?: boolean;
  isTeiaHeader?: boolean;
  $collapsed?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$collapsed ? 'center' : 'flex-start')};
  padding: ${(props) => (props.$collapsed ? '8px' : '8px 8px 8px 15px')};
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
  background: ${(props) =>
    props.isActive
      ? props.isTeiaHeader
        ? '#F7941E'
        : '#5F2AB2'
      : 'transparent'};
  transition: background 0.3s;

  &:hover {
    background: ${(props) => (props.isTeiaHeader ? '#F7941E' : '#5F2AB2')};
  }
`;

export const HeaderIcon = styled(FontAwesomeIcon)<{ $collapsed?: boolean }>`
  width: 24px;
  height: 24px;
  margin-right: ${(props) => (props.$collapsed ? '0' : '14px')};
  color: var(--white);
  flex-shrink: 0;
`;

export const HeaderTitle = styled.span`
  flex: 1;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 2.5;
  letter-spacing: 0.5px;
  color: var(--white);
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChevronIcon = styled(FontAwesomeIcon)`
  width: 16px;
  height: 16px;
  color: var(--white);
  flex-shrink: 0;
  margin-right: 4px;
`;

export const SubList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SubItemLink = styled(Link)<{ isActive?: boolean; isTeiaHeader?: boolean }>`
  display: block;
  padding: 8px 8px 8px 54px;
  width: 100%;
  box-sizing: border-box;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 2;
  text-decoration: none !important;
  text-align: left;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
  background: ${(props) =>
    props.isActive
      ? props.isTeiaHeader
        ? '#F7941E'
        : '#5F2AB2'
      : 'transparent'};
  transition: background 0.3s;

  &&,
  &&:link,
  &&:visited {
    color: var(--white) !important;
  }

  &:hover,
  &:focus,
  &:focus-visible,
  &:active {
    color: var(--white) !important;
    outline: none;
    background: ${(props) =>
      props.isActive
        ? props.isTeiaHeader
          ? '#F7941E'
          : '#5F2AB2'
        : props.isTeiaHeader
          ? '#F7941E'
          : '#5F2AB2'};
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;
